import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
        width: 100vw;
    }

    a:hover {
        color: #rgb(0, 0, 0);
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: #rgb(0, 0, 0);
        font-size: 28px;
        line-height: 0.5;

        @media only screen and (max-width: 890px) {
          font-size: 28px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 28px;
        }
    }

    p {
        color:rgb(0, 0, 0);
        font-size: 11pt;        
        line-height: 1.4;
        white-space: pre-line;
        text-align: justify;

        /* padding: 0.1rem 0 0.75rem; */
        /* background-color: white; */
        /* text-align: justify; */
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: rgb(0, 0, 0);

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.0rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
